import Vue from "vue"
import spacetime from "spacetime"

Vue.filter("daysLeft", ts => {
  if (!ts) return ""
  let expiresAt = spacetime(ts * 1000)
  let now = spacetime.now()
  return now.diff(expiresAt, "day")
})
